export default __webpack_public_path__ + "static/char-s-38-ja-0eaf814488716f5b60feb75e22aca27a.png";